<script setup lang="ts">
import type { Component } from "vue";

defineProps<{
  label: string;
  value: string | number;
  hint: string;
  icon: Component;
  tone?: "lime" | "coral" | "cream" | "mint";
}>();
</script>

<template>
  <article class="metric-card" :class="`tone-${tone || 'cream'}`">
    <span class="metric-glow" aria-hidden="true" />
    <div class="metric-card-top">
      <span>{{ label }}</span>
      <span class="metric-icon"><component :is="icon" :size="18" /></span>
    </div>
    <strong class="metric-value">{{ value }}</strong>
    <p>{{ hint }}</p>
    <span class="metric-signal" aria-hidden="true"><i /><i /><i /><i /><i /></span>
  </article>
</template>
